import { Component, OnInit } from '@angular/core';
import { DonneReferenceService } from '../../../shared/services/donne-reference.service';
import { GtmService } from '../../../shared/services/gtm.service';
import { GTM_PUSH_CATEGORY_PAGE_VUE, GTM_PUSH_CATEGORY } from '../../../shared/modeles/variables';

@Component({
  selector: 'app-page-non-authentifie',
  templateUrl: './page-non-authentifie.component.html',
  styleUrls: ['./page-non-authentifie.component.scss'],
  standalone: false
})
export class PageNonAuthentifieComponent implements OnInit {
  telephoneMontreal: string;
  telephoneSansFrais: string;

  contextualText: string = null;
  pageTitle = 'page-non-authentifie.titre';

  constructor(
    private readonly _donneeReferencesService: DonneReferenceService,
    private readonly _gtmService: GtmService
  ) {}

  ngOnInit() {
    this.telephoneMontreal = this._donneeReferencesService.numerosDemandeSupport.montreal;
    this.telephoneSansFrais = this._donneeReferencesService.numerosDemandeSupport.sansFrais;

    this.pushGtmInitEvents();
  }

  private pushGtmInitEvents() {
    this._gtmService.pushEvent({
      event: GTM_PUSH_CATEGORY_PAGE_VUE,
      category: GTM_PUSH_CATEGORY,
      label: `challenge otp`,
      action: 'challenge fail'
    });
  }

  getBackgroundImageSource() {
    return {
      desktop: '/page-background/background-5-desktop.jpg'
    };
  }
}
